import React, { useEffect, useState } from 'react'
import { useTranslation } from '../../../locale/useTranslation';
import { EditPageHeader } from '../../../components/EditPageHeader';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { DAYS, ENTITYNAME, LOGEVENT, MEDIACATEGORIES, MODULE, PRIORITY, TOAST_TYPES } from '../../../framework/constant/constant';
import CollectionSelection from '../../../framework/forms/CollectionSelection';
import { utility } from '../../../framework/utility/utilityProvider';
import * as API from "../../../framework/API/api";
import BossDialog from '../../../components/BossDialog';
import TrailerBooking from '../../TrailerBooking/TrailerBooking';
import moment from 'moment';
import ToastNotification from '../../../components/ToastNotification';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import AddRoundButton from '../../../framework/forms/helpercomponents/buttons/AddRoundButton';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import DeleteRoundButton from '../../../framework/forms/helpercomponents/buttons/DeleteRoundButton';
import { ConfirmDeleteAlert } from '../../../ConfirmAlert';
import { TimeCell } from '../../../framework/forms/helpercomponents/CustomGridCells/TimeCell';
import TargetsEditForm from '../../Interstitial/TargetsEditForm';

const TrailerCampaignEditForm = () => {

    const lang = useTranslation();
    const loc = useLocation();
    const { SID } = useParams();
    const navigate = useNavigate();
    const [tabNumber, setTabNumber] = useState("1");

    const blankDataItem = {
        Title: "",
        Description: "",
        Genre: {},
        ClashGenre: {},
        Archive: false,
        Priority: Object.keys(PRIORITY).map((x) => {
            return {
                _id: PRIORITY[x],
                Description: x
            }
        }).find(x => x._id == PRIORITY.Medium)?._id,
        Producer: "",
        Color: "",
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [broadcastWindowsData, setBroadcastWindowsData] = useState([]);
    const [showTrailerIngestDialog, setShowTrailerIngestDialog] = useState(false);
    const [trailersGridData, setTrailersGridData] = useState([]);
    const [genres, setGenres] = useState([]);
    const [openCommercials, setOpenCommercials] = useState(false);
    const [targetData, setTargetData] = useState([]);

    useEffect(() => {
        loadCombo();
        if (SID > 0) {
            loadEditData();
        }
    }, []);

    const loadCombo = async () => {
        let genreRes = await API.getDataLookup(ENTITYNAME.Genre, { sort: { Description: 1 } });
        setGenres(genreRes.data);
    }

    const loadEditData = async () => {
        const res = await API.getEntity(ENTITYNAME.TrailerCampaign, parseInt(SID));
        if (!res?.success || !res?.data?._id) return;

        setDataItem({
            ...res?.data,
            Priority: (res?.data?.Priority != undefined || res?.data?.Priority != null) ? { _id: res?.data?.Priority, Description: utility.getKeyByValue(PRIORITY, res?.data?.Priority) } : null,
            Name: loc.state?.copy ? `Copy of ${res?.data.Name}` : res?.data?.Name,
            Color: res?.data?.Color ? res?.data?.Color.startsWith("#") ? res?.data?.Color : `#${res?.data?.Color}` : "#000000",
            Archive: res?.data?.Archive ?? false,
        });

        setBroadcastWindowsData(res?.data?.BroadCastWindow);
        const trailers = res?.data.Trailers ?? [];
        if (trailers?.length > 0) {
            let interstitalData = await API.getData(ENTITYNAME.MediaEpisode, { query: [["_id", "in", res?.data.Trailers.map(x => x.mediaEpisode_id)]] });
            interstitalData = interstitalData?.data ?? [];
            if (!interstitalData.length) return setTrailersGridData([]);
            const trailersWithEpisode = trailers.map(x => {
                const interstitial = interstitalData?.find(y => y._id == x?.mediaEpisode_id)
                return { ...(interstitial || {}), TrailersConfig: x };
            });
            setTrailersGridData(trailersWithEpisode);
        }

        setTargetData(res?.data?.Targets ?? []);
    };

    const handleTabChange = (event, newValue) => {
        setTabNumber(`${newValue}`);
    };

    const onChange = (e) => {
        if (e.target.name === "Color") {
            setDataItem(prev => ({ ...prev, Color: e.target.value }));
        } else if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const isValid = () => {
        if (!dataItem?.Title || dataItem?.Title.trim() == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_title_error_message });
            return false;
        }

        if (!dataItem?.Genre || Object.keys(dataItem?.Genre).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_genre_error_message });
            return false;
        }

        if (!dataItem?.ClashGenre || Object.keys(dataItem?.ClashGenre).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select__clash_genre_error_message });
            return false;
        }

        return true;
    }

    const onSave = async () => {

        if (!isValid()) return;

        const saveData = {
            _id: dataItem?._id,
            SID: dataItem?.SID,
            Title: dataItem?.Title,
            Description: dataItem?.Description,
            Color: dataItem?.Color ?? null,
            Genre: dataItem.Genre?._id ? { _id: dataItem.Genre._id, Description: dataItem.Genre.Description } : {},
            ClashGenre: dataItem.ClashGenre?._id ? { _id: dataItem.ClashGenre._id, Description: dataItem.ClashGenre.Description } : {},
            Producer: dataItem.Producer,
            Priority: dataItem.Priority?._id,
            Archive: dataItem.Archive ?? false, 
            BroadCastWindow: broadcastWindowsData,
            Trailers: trailersGridData?.length > 0 ? trailersGridData?.map(item => {
                return {
                    mediaEpisode_id: item?._id,
                    ...item?.TrailersConfig
                }
            }) : [],
            Targets: targetData?.length > 0 ? targetData : [],
            checkDuplicate: true,
            query: [["Title", "=", dataItem.Title]],
        }

        if (loc.state.copy) {
            delete saveData?._id;
            delete saveData?.SID;
        }

        console.log(saveData);
        const res = await API.saveData(ENTITYNAME.TrailerCampaign, saveData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.TRAILER_CAMPAIGN, data: res.data, message: res.message };
            API.SaveLogs(logData)
            utility.deleteLocalStorageItem(ENTITYNAME.TrailerCampaign);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        navigate(-1);
    }

    const overlaps = (start1, end1, start2, end2) => start1 <= end2 && start2 <= end1;

    const handleTrailerIngestComplete = (ingestedItems) => {
        
        setTrailersGridData(prev => [...prev, ...ingestedItems]);
        const defaultValidDays = DAYS.map(d => d.ID);

        const blankDataItem = {
            Channels: [],
            FromDate: moment().format("YYYY-MM-DD"),
            ToDate: moment().add(7, 'days').format("YYYY-MM-DD"),
            FromTime: "00:00",
            ToTime: "23:59",
            TargetType: {},
            TargetValue: null,
            ValidDays: defaultValidDays
        };
        setBroadcastWindowsData(prev => {
            let updatedData = [...prev];

            ingestedItems.forEach(item => {
                const itemStart = moment(item.StartDate);
                const itemEnd = moment(item.EndDate);
                const itemChannels = item.Channels || [];

                let merged = false;

                updatedData = updatedData.map(broadcast => {
                    const broadcastStart = moment(
                        `${broadcast.FromDate} ${broadcast.FromTime}`
                    );
                    const broadcastEnd = moment(
                        `${broadcast.ToDate} ${broadcast.ToTime}`
                    );

                    if (
                        // sameChannels(itemChannels, broadcast.Channels) &&
                        overlaps(itemStart, itemEnd, broadcastStart, broadcastEnd)
                    ) {
                        merged = true;

                        const newStart = moment.min(broadcastStart, itemStart);
                        const newEnd = moment.max(broadcastEnd, itemEnd);

                        return {
                            ...broadcast,
                            FromDate: newStart.format("YYYY-MM-DD"),
                            FromTime: newStart.format("HH:mm"),
                            ToDate: newEnd.format("YYYY-MM-DD"),
                            ToTime: newEnd.format("HH:mm"),
                        };
                    }

                    return broadcast;
                });

                if (!merged) {
                    updatedData.push({
                        ...blankDataItem,
                        FromDate: itemStart.format("YYYY-MM-DD"),
                        FromTime: itemStart.format("HH:mm"),
                        ToDate: itemEnd.format("YYYY-MM-DD"),
                        ToTime: itemEnd.format("HH:mm"),
                        Channels: itemChannels,
                    });
                }
            });

            setShowTrailerIngestDialog(false);
            return updatedData;
        });

    }

    const deleteSelectedCommercial = async (item) => {
        setTrailersGridData(prev => prev.filter(commercial => commercial._id !== item._id));
    }

    const MyCommercialCommandCell = (props) => (
        <td style={{}}>
            <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => deleteSelectedCommercial(props.dataItem), () => { })} />
        </td>
    )

    const commercialGridRowRender = (tr, props) => {

        const trProps = {
            style: props.dataItem.Archive ? { backgroundColor: "#FF0032" } : { backgroundColor: "#FFFFFF" },
        };

        return React.cloneElement(tr, { ...trProps }, tr.props.children);
    };

    return (<>
        <div className="p-2">
            <EditPageHeader title={dataItem?.Title != "" ? dataItem?.Title : lang.trailer_label} onSubmit={onSave} onCancel={() => navigate(-1)} showTitle={false} />
            <div className="row mt-2">
                <div className="col-12">
                    <div className="row">
                        <div className="col-6">
                            <label>{lang.title_label} <span style={{ color: 'red' }}>*</span></label>
                            <input
                                name="Title"
                                type="text"
                                className="form-control form-control-sm"
                                onChange={onChange}
                                value={dataItem.Title}
                            />
                        </div>
                        <div className="col-6">
                            <label>{lang.description_label}</label>
                            <input
                                name="Description"
                                type="text"
                                className="form-control form-control-sm"
                                onChange={onChange}
                                value={dataItem.Description}
                            />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-3">
                            <label>{lang.genre_label} <span style={{ color: 'red' }}>*</span></label>
                            <DropDownList
                                data={genres}
                                name="Genre"
                                dataItemKey="_id"
                                textField="Description"
                                onChange={onChange}
                                value={dataItem.Genre}
                                style={{ backgroundColor: 'white', height: '32px' }}
                            />
                        </div>
                        <div className="col-3">
                            <label>{lang.clash_genre_label} <span style={{ color: 'red' }}>*</span></label>
                            <DropDownList
                                data={genres}
                                name="ClashGenre"
                                dataItemKey="_id"
                                textField="Description"
                                onChange={onChange}
                                value={dataItem.ClashGenre}
                                style={{ backgroundColor: 'white', height: '32px' }}
                            />
                        </div>
                        <div className="col-2">
                            <label>{lang.priority_label}</label>
                            <DropDownList
                                data={Object.keys(PRIORITY).map((x) => {
                                    return {
                                        _id: PRIORITY[x],
                                        Description: x
                                    }
                                })}
                                name="Priority"
                                textField="Description"
                                dataItemKey="_id"
                                value={dataItem.Priority}
                                onChange={onChange}
                            />
                        </div>
                        <div className="col-3">
                            <label>{lang.producer_label}</label>
                            <input
                                name="Producer"
                                type="text"
                                className="form-control form-control-sm"
                                onChange={onChange}
                                value={dataItem.Producer}
                            />
                        </div>
                        <div className="col-1">
                            <label>{lang.color_label}</label>
                            <input
                                name="Color"
                                type="color"
                                className="form-control form-control-sm"
                                onChange={onChange}
                                value={dataItem.Color}
                            />
                        </div>
                        <div className="col-2 mt-4">
                            <input
                                name="Archive"
                                type="checkbox"
                                value={dataItem.Archive}
                                checked={dataItem.Archive}
                                onChange={onChange}
                            />
                            <label className="ml-1">{lang.archive}</label>
                        </div>
                    </div>
                </div>
            </div>
            <Box sx={{ width: '100%', typography: 'body1', marginTop: "5px" }}>
                <TabContext value={tabNumber}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                                <Tab label={lang.promos_trailers_label} value="1" />
                                <Tab label={lang.targets_label} value="2" />
                            </TabList>
                        </Box>
                    </Box>
                    <TabPanel value={"1"}>
                        <>
                            <AddRoundButton title={lang.add_commercial_button_tooltip} style={{ marginLeft: "-15px" }} onClick={() => setOpenCommercials(true)} />
                            <Grid data={trailersGridData} style={{ height: "calc(100vh - 420px)", margin: "5px -15px 40px -15px" }} rowRender={commercialGridRowRender} resizable={true}>
                                <GridColumn cell={MyCommercialCommandCell} width={"70px"} locked={true} />
                                <GridColumn field="Title" title={lang.title_column} editable={false} />
                                <GridColumn field="MediaCategoryType.Description" title={lang.media_category_type_column} editable={false} />
                                <GridColumn field="AssetId" title={lang.assetId_column} editable={false} />
                                <GridColumn field="TcIn" title={lang.tc_in_label} editable={false} cell={TimeCell} />
                                <GridColumn field="TcOut" title={lang.tc_out_label} editable={false} cell={TimeCell} />
                                <GridColumn field="Duration" title={lang.duration_column} editable={false} cell={TimeCell} />
                            </Grid>
                            {openCommercials && <CollectionSelection title={lang.commercials_collection_header} entityname={ENTITYNAME.MediaEpisode} wherestatement={[['MediaCategory.SID', 'in', [MEDIACATEGORIES.Interstitial]],]} closeForm={() => setOpenCommercials(!openCommercials)} setDataList={(dataList) => setTrailersGridData((old) => [...old, ...dataList])} width={"50vw"} existingItems={trailersGridData} checkDuplicate={true} showCreate={true} path={`/home/MediaEpisode/Interstitial/0?page=1`} />}
                        </>
                    </TabPanel>
                    <TabPanel value={"2"}>
                        <TargetsEditForm targetData={targetData} setTargetData={setTargetData} />
                    </TabPanel>
                </TabContext>
            </Box>
        </div>
        {showTrailerIngestDialog && <BossDialog title={'Ingest Trailer'} onClose={() => setShowTrailerIngestDialog(false)} width={"50vw"}><TrailerBooking onIngestComplete={handleTrailerIngestComplete} /></BossDialog>}
    </>
    )
}

export default TrailerCampaignEditForm